import { render, staticRenderFns } from "./core_paragraph.vue?vue&type=template&id=7f391a81&scoped=true"
import script from "./core_paragraph.vue?vue&type=script&lang=js"
export * from "./core_paragraph.vue?vue&type=script&lang=js"
import style0 from "./core_paragraph.vue?vue&type=style&index=0&id=7f391a81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f391a81",
  null
  
)

export default component.exports